import { Collapse, Divider, Grid, Typography } from "@mui/material"
import { ISettingsItem } from "../../../Settings"
import { usePlan } from '../../../Plans'
import { useInitReq } from "../../../InitReq"
import { useTranslation } from "../../../i18n"
import CheckboxDefault from '../../CheckboxDefault'
import SelectPickUpChip from "./SelectPickUpChip"

export default function SelectChipInfo({ name, variables }: ISettingsItem) {
  const { virtualChip, currentPlan, chosenPlan, updatePlanState, setvirtualChip } = usePlan()
  const { chipInfo: { chipPrice, logisticPlans, pickUpInStore } } = useInitReq()
  const { t } = useTranslation()
  const { text } = variables || {}
  const planChipPrice = logisticPlans?.find(({ id }) => id === `${currentPlan.id}`)
  const parsedChipPriceNVMO = (parseFloat(chipPrice ?? "0.00") + parseFloat(planChipPrice?.repasse_mvno_logistica_chip_plano ?? "0.00") || 0).toFixed(2).replace('.', ',')
  const parsedEsimPriceNVMO = (parseFloat(planChipPrice?.repasse_mvno_ativacao_chip_esim ?? "0.00") || 0).toFixed(2).replace('.', ',')
  const defaultTextArray = [
    t.page2.chipInfo.physicalChipHtml,
    t.page2.chipInfo.physicalChipDesc,
    t.page2.chipInfo.receiveAtHome,
    t.page2.chipInfo.receiveAtHomeDesc,
    t.page2.chipInfo.pickUpInStore,
    t.page2.chipInfo.pickUpInStoreDesc,
    t.page2.chipInfo.virtualChip,
    t.page2.chipInfo.virtualChipDesc,
  ]
  const mergedArray = text
    ? text.map((value, index) => (value !== undefined && value !== '' ? value : defaultTextArray[index]))
    : defaultTextArray

  const handleVirtualChipChange = (chipType: string) => {
    const isVirtualChip = chipType === 'virtual'
    setvirtualChip(isVirtualChip)
    if (isVirtualChip) updatePlanState({ pickUpChip: false })
  }

  // PICK UP TEXT
  const pickUpVariables = {
    text: mergedArray.slice(2, 6)
  }

  return (
    <Grid
      container
      item
      className={name ? `${name} select-chip-info` : "select-chip-info"}
      xs={12}
    >
      {chosenPlan !== 'annual' && (
        <>
          <Grid container item className="chip physicalChip" xs={12}>
            <Grid container item className="checkArea">
              <CheckboxDefault
                checked={!virtualChip}
                onChange={() => handleVirtualChipChange('physical')}
              />
              <Grid item className="textAreaChipInfo">
                <Typography variant="h3" dangerouslySetInnerHTML={{ __html: mergedArray[0] }} />
                <Typography variant="body2" dangerouslySetInnerHTML={{ __html: mergedArray[1] }} />
              </Grid>
            </Grid>
            <Grid item className="priceAreaChipInfo">
              <Typography variant="h3" dangerouslySetInnerHTML={{ __html: `+ R$ ${parsedChipPriceNVMO}` }} />
            </Grid>
          </Grid>

          {pickUpInStore && (
            <Collapse in={!virtualChip} sx={{ width: '100%' }}>
              <SelectPickUpChip variables={pickUpVariables} />
            </Collapse>
          )}

          <Divider sx={{ width: '100%' }} />
        </>
      )}

      <Grid container item className="chip virtualChip" xs={12}>
        <Grid container item className="checkArea">
          <CheckboxDefault
            checked={virtualChip}
            onChange={() => handleVirtualChipChange('virtual')}
          />
          <Grid item className="textAreaChipInfo">
            <Typography variant="h3" dangerouslySetInnerHTML={{ __html: mergedArray[6] }} />
            <Typography variant="body2" dangerouslySetInnerHTML={{ __html: mergedArray[7] }} />
          </Grid>
        </Grid>
        <Grid item className="priceAreaChipInfo">
          <Typography variant="h3" dangerouslySetInnerHTML={{ __html: `+ R$ ${parsedEsimPriceNVMO}` }} />
        </Grid>
      </Grid>
    </Grid>
  )
}